/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientEntity } from './ClientEntity';
import {
    ClientEntityFromJSON,
    ClientEntityFromJSONTyped,
    ClientEntityToJSON,
} from './ClientEntity';

/**
 * A payload containing client entities associated with a single resourceId
 * @export
 * @interface AssociatedClientsForResource
 */
export interface AssociatedClientsForResource {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof AssociatedClientsForResource
     */
    subjectRID?: string;
    /**
     * 
     * @type {Array<ClientEntity>}
     * @memberof AssociatedClientsForResource
     */
    clients?: Array<ClientEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof AssociatedClientsForResource
     */
    canAddTagsToSubject?: boolean;
}

/**
 * Check if a given object implements the AssociatedClientsForResource interface.
 */
export function instanceOfAssociatedClientsForResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssociatedClientsForResourceFromJSON(json: any): AssociatedClientsForResource {
    return AssociatedClientsForResourceFromJSONTyped(json, false);
}

export function AssociatedClientsForResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociatedClientsForResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectRID': !exists(json, 'subjectRID') ? undefined : json['subjectRID'],
        'clients': !exists(json, 'clients') ? undefined : ((json['clients'] as Array<any>).map(ClientEntityFromJSON)),
        'canAddTagsToSubject': !exists(json, 'canAddTagsToSubject') ? undefined : json['canAddTagsToSubject'],
    };
}

export function AssociatedClientsForResourceToJSON(value?: AssociatedClientsForResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectRID': value.subjectRID,
        'clients': value.clients === undefined ? undefined : ((value.clients as Array<any>).map(ClientEntityToJSON)),
        'canAddTagsToSubject': value.canAddTagsToSubject,
    };
}

